import { LinearProgress } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'

export default function RiskIntelligenceDataGrid({ rows, columns, isLoading }: any) {
  return (
    <DataGrid
      hideFooterSelectedRowCount
      getRowId={(row) => row.id}
      sx={{
        border: 0,
        '& .MuiDataGrid-row:hover': {
          backgroundColor: 'rgba(235, 235, 235, 0.7)',
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: '#FFFFFF',
          color: '#5B5B5B',
          fontSize: '15px',
          fontFamily: 'Segoe UI',
          borderBottom: '2px solid #BABABA',
        },
        '& .MuiDataGrid-cell': {
          borderBottom: `1px solid #BABABA`,
          color: '#000000',
          fontSize: '12px',
          fontFamily: 'Segoe UI',
          cursor: 'pointer',
          fontWeight: '600',
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& ::-webkit-scrollbar': {
          width: '5px',
        },
        '& ::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1',
        },
        '& ::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '5px',
          '&:hover': {
            backgroundColor: '#555',
          },
        },
        '& .MuiDataGrid-toolbarContainer .MuiButtonBase-root': {
          color: '#5B5B5B',
        },
        '& .MuiDataGrid-toolbarContainer .MuiSvgIcon-root': {
          fill: '#5B5B5B',
        },
      }}
      rows={rows || []}
      columns={columns}
      loading={isLoading}
      slots={{
        toolbar: GridToolbar,
        loadingOverlay: LinearProgress,
      }}
    />
  )
}
